"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachAssetLibrary = exports.AssetLibrary = void 0;
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var react_1 = __importDefault(require("react"));
var Types_1 = require("Common/AssetLibrary/Types");
var ImageLibraryDataStore_1 = require("Common/AssetLibrary/ImageLibrary/ImageLibraryDataStore");
var RecentlyUsedDataStore_1 = __importDefault(require("Common/AssetLibrary/ImageLibrary/SystemFolderStores/RecentlyUsed/RecentlyUsedDataStore"));
var UploadsDataStore_1 = __importDefault(require("Common/AssetLibrary/ImageLibrary/SystemFolderStores/Uploads/UploadsDataStore"));
var UnsplashDataStore_1 = __importDefault(require("Common/AssetLibrary/ImageLibrary/SystemFolderStores/Unsplash/UnsplashDataStore"));
var ImageLibrary_1 = require("Common/AssetLibrary/ImageLibrary/ImageLibrary");
var InvalidAssetTypeError_1 = __importDefault(require("Common/AssetLibrary/Error/InvalidAssetTypeError"));
var ImageLibraryViewStore_1 = require("Common/AssetLibrary/ImageLibrary/ImageLibraryViewStore");
var ImageLibraryUtils_1 = require("Common/AssetLibrary/ImageLibrary/ImageLibraryUtils");
var RecentlyUsedViewStore_1 = __importDefault(require("Common/AssetLibrary/ImageLibrary/SystemFolderStores/RecentlyUsed/RecentlyUsedViewStore"));
var UploadsViewStore_1 = __importDefault(require("Common/AssetLibrary/ImageLibrary/SystemFolderStores/Uploads/UploadsViewStore"));
var UnsplashViewStore_1 = __importDefault(require("Common/AssetLibrary/ImageLibrary/SystemFolderStores/Unsplash/UnsplashViewStore"));
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var DashboardFoldersViewStore_1 = require("Dashboard/Stores/DashboardFoldersViewStore");
var Types_2 = require("@CommonFrontendBackend/Folders/Types");
var AssetLibrary = (function (_super) {
    __extends(AssetLibrary, _super);
    function AssetLibrary(props) {
        var e_1, _a;
        var _this = _super.call(this, props) || this;
        _this.assetLibraryStores = new Map();
        _this.selectedAssetType = Types_1.AssetType.Image;
        try {
            for (var _b = __values(props.assetLibraryStores), _c = _b.next(); !_c.done; _c = _b.next()) {
                var store = _c.value;
                _this.assetLibraryStores.set(store.type, store);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return _this;
    }
    AssetLibrary.prototype.render = function () {
        if ((0, ImageLibraryUtils_1.isImageLibraryDataStore)(this.selectedDataStore) && (0, ImageLibraryUtils_1.isImageLibraryViewStore)(this.selectedViewStore)) {
            var _a = this.props, folderSelectionViewStore = _a.folderSelectionViewStore, foldersViewStore = _a.foldersViewStore, uploadStore = _a.uploadStore, useAssetCallback = _a.useAssetCallback, launchOptions = _a.launchOptions, modal = _a.modal, notifyUser = _a.notifyUser;
            return (react_1.default.createElement(ImageLibrary_1.ImageLibrary, { dataStore: this.selectedDataStore, viewStore: this.selectedViewStore, uploadStore: uploadStore, useAssetCallback: useAssetCallback, launchOptions: launchOptions, folderSelectionViewStore: folderSelectionViewStore, foldersViewStore: foldersViewStore, modal: modal, notifyUser: notifyUser }));
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    };
    Object.defineProperty(AssetLibrary.prototype, "selectedDataStore", {
        get: function () {
            return this.assetLibraryStores.get(this.selectedAssetType).dataStore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetLibrary.prototype, "selectedViewStore", {
        get: function () {
            return this.assetLibraryStores.get(this.selectedAssetType).viewStore;
        },
        enumerable: false,
        configurable: true
    });
    AssetLibrary.prototype.selectAssetType = function (assetType) {
        if (!this.assetLibraryStores.has(assetType)) {
            throw new InvalidAssetTypeError_1.default("No asset store found for \"".concat(assetType, "\""));
        }
        this.selectedAssetType = assetType;
    };
    var _a, _b;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof Types_1.AssetType !== "undefined" && Types_1.AssetType) === "function" ? _a : Object)
    ], AssetLibrary.prototype, "selectedAssetType", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof Types_1.AssetType !== "undefined" && Types_1.AssetType) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], AssetLibrary.prototype, "selectAssetType", null);
    AssetLibrary = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AssetLibrary);
    return AssetLibrary;
}(react_1.default.Component));
exports.AssetLibrary = AssetLibrary;
var attachAssetLibrary = function (mountReactComponent, uploadStore, recentlyUsedService, uploadsService, imageService, imageResourceApiService, stockImageService, usingFeature, modal, notifyUser, rootDataStore) {
    return {
        launch: function (useAssetCallback, launchOptions) {
            if (launchOptions === void 0) { launchOptions = {}; }
            var disableImgix = usingFeature(FeatureFlag_1.default.DisableImgix);
            var recentlyUsedDataStore = new RecentlyUsedDataStore_1.default(recentlyUsedService);
            var uploadsDataStore = new UploadsDataStore_1.default(uploadsService, imageResourceApiService, disableImgix);
            var unsplashDataStore = new UnsplashDataStore_1.default(imageService, stockImageService);
            var imageLibrarySystemFolderDataStores = [unsplashDataStore, recentlyUsedDataStore, uploadsDataStore];
            var recentlyUsedViewStore = new RecentlyUsedViewStore_1.default(recentlyUsedDataStore);
            var uploadsViewStore = new UploadsViewStore_1.default(uploadsDataStore);
            var unsplashViewStore = new UnsplashViewStore_1.default(unsplashDataStore);
            var imageLibrarySystemFolderViewStores = [unsplashViewStore, recentlyUsedViewStore, uploadsViewStore];
            var imageLibraryDataStore = new ImageLibraryDataStore_1.ImageLibraryDataStore(imageLibrarySystemFolderDataStores);
            var imageLibraryViewStore = new ImageLibraryViewStore_1.ImageLibraryViewStore(useAssetCallback, imageLibrarySystemFolderViewStores);
            var folderSelectionViewStore = new kaleidoscope_1.FolderSelectionViewStore();
            var imageFolderViewStore = undefined;
            if (usingFeature(FeatureFlag_1.default.ImageFolders)) {
                var imageFoldersDataStore = rootDataStore.imageFoldersDataStore;
                imageFoldersDataStore.fetch();
                imageFolderViewStore = new DashboardFoldersViewStore_1.DashboardFoldersViewStore(folderSelectionViewStore, imageFoldersDataStore, modal, Types_2.CollectionType.UploadedImage);
            }
            return mountReactComponent(react_1.default.createElement(AssetLibrary, { assetLibraryStores: [
                    { type: Types_1.AssetType.Image, dataStore: imageLibraryDataStore, viewStore: imageLibraryViewStore },
                ], uploadStore: uploadStore, useAssetCallback: useAssetCallback, launchOptions: launchOptions, folderSelectionViewStore: folderSelectionViewStore, foldersViewStore: imageFolderViewStore, modal: modal, notifyUser: notifyUser }));
        },
    };
};
exports.attachAssetLibrary = attachAssetLibrary;
